import { combineReducers } from 'redux'
import auth from './auth'
import announcement from './announcement'
import brand from './brand'
import brandNews from './brandNews'
import brandCover from './brandCover'
import bin from './bin'
import material from './material'
import barcodeProduct from './barcodeProduct'
import reports from './reports'
import hero from './hero'
import productFeature from './productFeature'
import location from './location'
import heroNewsItems from './heroNewsItems'

export default combineReducers({
  auth,
  announcement,
  brand,
  brandNews,
  brandCover,
  bin,
  material,
  barcodeProduct,
  reports,
  hero,
  heroNewsItems,
  productFeature,
  location
})



// WEBPACK FOOTER //
// ./src/stores/index.js